module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product14-6fe7e1cc512b2b7aea4626d358a2f113.jpg";